import { AppDispatch } from '../redux/store';
import { getProjectProductTagsByProjectProductIdsAction } from '../redux/actions/projectProductTagActions';

// Batch size for fetching project product tags.
export const TAGS_BATCH_SIZE = 50;

export type ProjectProductTagLike = {
    projectProductId: number;
    tag?: { name?: string };
    name?: string;
};

export const fetchTagsInBatches = async (
    dispatch: AppDispatch,
    projectProductIds: number[],
): Promise<ProjectProductTagLike[]> => {
    const allTags: ProjectProductTagLike[] = [];

    for (let i = 0; i < projectProductIds.length; i += TAGS_BATCH_SIZE) {
        const batch = projectProductIds.slice(i, i + TAGS_BATCH_SIZE);
        if (!batch.length) {
            continue;
        }
        const { payload } = (await dispatch(
            getProjectProductTagsByProjectProductIdsAction(batch),
        )) as { payload?: ProjectProductTagLike[] };

        if (Array.isArray(payload)) {
            allTags.push(...payload);
        }
    }

    return allTags;
};
